const API_URL = import.meta.env.VITE_API_URL || '';

const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL || '';

const PICSART_APP_URL = import.meta.env.VITE_PICSART_APP_URL || '';

const LIBRARY_TABS_KEY = import.meta.env.VITE_LIBRARY_TABS_KEY || '';

const LIBRARY_BASE_URL = import.meta.env.VITE_LIBRARY_URL || '';

const LIBRARY_SECTIONS_URL = `${LIBRARY_BASE_URL}/hubs/${LIBRARY_TABS_KEY}/grids/flow?landingType=flow&expand=uploadItems,textItems`;

const LIBRARY_TRENDING_URL = `${LIBRARY_BASE_URL}/hubs/${LIBRARY_TABS_KEY}/trending`;

const FLOW_LANDINGS_URL = `${LIBRARY_BASE_URL}/flow-landings/slug`;

/** Server caps `pagination[pageSize]` at 100; larger values are silently clamped. */
const NEW_PRESETS_PAGE_SIZE = 25;

/** `width`/`height` sit top-level on images but only inside `provider_metadata` on videos. */
const NEW_PRESETS_MEDIA_FIELDS = 'url,width,height,provider_metadata';

const NEW_PRESETS_QUERY = new URLSearchParams({
  sort: 'createdAt:desc',
  'pagination[pageSize]': String(NEW_PRESETS_PAGE_SIZE),
  'filters[hideFromPicsart][$eq]': 'false',
  fields: 'slug,title,type,description,flow',
  'populate[video][populate][media][fields]': NEW_PRESETS_MEDIA_FIELDS,
  'populate[image][populate][media][fields]': NEW_PRESETS_MEDIA_FIELDS,
}).toString();

const NEW_PRESETS_URL = `${LIBRARY_BASE_URL}/flow-landings?${NEW_PRESETS_QUERY}`;

const MAGIC_FLOW_WEBHOOK_URL = `${API_URL}/workflows/magic-flow-webhook`;

const SUBMIT_WEB_HOOK_URL = `${MAGIC_FLOW_WEBHOOK_URL}/submit`;

const CREDIT_CALCULATOR_URL = `${API_URL}/workflows/magic-flow-webhook-calculator/execute`;

const FREE_PASS_API_URL = import.meta.env.VITE_FREE_PASS_API_URL || '';

const FREE_PASS_PROMO_ID = import.meta.env.VITE_FREE_PASS_PROMO_ID || '';

const MOBILE_EDITOR_URL = 'picsart://apps';

const SIGNOUT_URL = `${API_URL}/users/signout.json`;

const DRIVE_FILES_URL = `${API_URL}/drive/v1/files`;

export {
  API_URL,
  UPLOAD_URL,
  PICSART_APP_URL,
  LIBRARY_TABS_KEY,
  LIBRARY_BASE_URL,
  LIBRARY_SECTIONS_URL,
  LIBRARY_TRENDING_URL,
  FLOW_LANDINGS_URL,
  NEW_PRESETS_URL,
  MAGIC_FLOW_WEBHOOK_URL,
  SUBMIT_WEB_HOOK_URL,
  CREDIT_CALCULATOR_URL,
  FREE_PASS_API_URL,
  FREE_PASS_PROMO_ID,
  MOBILE_EDITOR_URL,
  SIGNOUT_URL,
  DRIVE_FILES_URL,
};
